import React from 'react';
import { Outlet, useLoaderData } from 'react-router-dom';
import formatAddress from '../Appointments/utils/formatAddress';

export default function Vendor() {
  const loaderData = useLoaderData();
  const { data } = loaderData;
  const addressObject = {
    street_address_1: data.address_1,
    street_address_2: data.address_2,
    city: data.city,
    state: data.state,
    country: data.country,
    zipcode: data.zipcode,
  };

  const completeAddress = formatAddress(addressObject);

  const vendor = {
    id: data.vendor_id,
    name: data.vendor_name || undefined,
    address: completeAddress || undefined,
    email: data.email || undefined,
    phone: data.phone || undefined,
    mobile: data.mobile || undefined,
    notes: data.notes || undefined,
    trade: data.vendor_trade || undefined,
    completeAddress,
    address1: data.address_1 || undefined,
    address2: data.address_2 || undefined,
    city: data.city || undefined,
    country: data.country || undefined,
    zipCode: data.zipcode || undefined,
    state: data.state || undefined,
    vendorLast: data.vendor_last || undefined,
    vendorFirst: data.vendor_name || undefined,
    einSsn: data.ein_ssn || undefined,
    photo: data.vendor_photo || undefined,
    insurance: data.insurance || undefined,
    insuranceExpireDate: data.insurance_expire_date || undefined,
    w9: data.w_9 || undefined,
  };

  return <Outlet context={vendor} />;
}
